import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { AvatarWrapper } from 'src/layouts/TabsContainerWrapper';
import BatteryCharging60Icon from '@mui/icons-material/BatteryCharging60';
import OutletIcon from '@mui/icons-material/Outlet';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import PowerInputIcon from '@mui/icons-material/PowerInput';
import SignalWifiConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiConnectedNoInternet4';
import BoltIcon from '@mui/icons-material/Bolt';
import { I_BoxDataValue } from '../Log/graph.util';
import inverterImage from 'src/Resources/images/inverter.png';
import acCurrentImage from 'src/Resources/images/ac-current.png';
import converterImage from 'src/Resources/images/converter.png';

export interface TopologyBoxProps {
  title: string;
  data?: I_BoxDataValue[];
  connected?: boolean;
}

function formatPower(value, unit) {
  if (isNaN(value)) {
    return '';
  }
  value = parseFloat(value);

  const prefixes = ['', 'k', 'M', 'G', 'T'];
  let magnitude = 0;
  let negative = false;

  if (value < 0) {
    value = -value;
    negative = true;
  }
  while (value >= 1000) {
    value /= 1000;
    magnitude++;
  }

  const roundedValue = value.toFixed(1);

  //Filter all values less than 1 Watts(why?)
  if (magnitude === 0 && value < 1 && unit === 'W') {
    //console.log('DROP THIS VALUE ' + value);
    return 0;
  }

  return negative === false
    ? `${roundedValue} ${prefixes[magnitude]}`
    : `-${roundedValue} ${prefixes[magnitude]}`;
}

function TopologyBox(props: TopologyBoxProps) {
  const isMobile = window.innerWidth <= 1490;

  return (
    <Card
      sx={{
        visibility:
          props.data &&
          typeof props.data[0].value === 'number' &&
          isNaN(props.data[0].value)
            ? 'hidden'
            : props.connected
            ? 'visible'
            : 'hidden',

        width: isMobile ? '90px' : '104px',
        height:
          props.title === 'Battery' || (props.title && props.title.startsWith('Battery '))
            ? '165px'
            : props.title === 'AC Loads' ||
            props.title === 'DC Loads' ||
            props.title === 'Pv Inverter' ||
            props.title === 'Pv DC-DC' ||
            props.title === 'PV' ||
            props.title === 'Loads'
              ? '100px'
              : props.title === 'Inverter'
                ? '150px'
                : '150px',
        backgroundColor: !props.data
          ? 'darkgrey'
          : props.title === 'Grid Bus' ||
            props.title === 'Island Bus' ||
            props.title === 'DC Link'
          ? '#f7b34d'
          : 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'center'
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'center'
          }}
        >
          {props.data && props.title === 'Battery' && props.data.length == 5 && (
            <Typography variant="h5" noWrap>
              {props.title} (x{props.data[4].value})
            </Typography>
          )}
          {props.title != 'Battery' && (
            <Typography variant="h5" noWrap>
              {props.title}
            </Typography>
          )}

          {!props.data && (
            <SignalWifiConnectedNoInternet4Icon
              style={{
                fontSize: 40,
                color: 'black',
                backgroundColor: 'darkgrey',
                padding: '5px',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px'
              }}
            ></SignalWifiConnectedNoInternet4Icon>
          )}

          {props.data && props.title === 'AC-DC' && (
            <img
              src={inverterImage}
              style={{
                width: '40px',
                height: '40px',
                color: 'orange'
              }}
            />
          )}

          {props.data && props.title === 'Inverter' && (
            <img
              src={inverterImage}
              style={{
                width: '40px',
                height: '40px',
                color: 'orange'
              }}
            />
          )}

          {props.data && props.title === 'DC Link' && (
            <PowerInputIcon
              style={{
                fontSize: 40,
                color: 'black',
                backgroundColor: '#f7b34d',
                padding: '5px',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px'
              }}
            ></PowerInputIcon>
          )}

          {props.data && props.title === 'DC-DC' && (
            <img
              src={converterImage}
              style={{
                width: '40px',
                height: '40px',
                color: 'orange'
              }}
            />
          )}

          {props.data &&
            (props.title === 'Grid Bus' || props.title === 'Island Bus') && (
              <img
                src={acCurrentImage}
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: '#f7b34d'
                }}
              />
            )}

          {props.data &&
            props.title != 'AC-DC' &&
            props.title != 'DC Link' &&
            props.title != 'DC-DC' && (
              <AvatarWrapper
                sx={{
                  display:
                    props.title === 'Grid Bus' || props.title === 'Island Bus'
                      ? 'none'
                      : 'flex',
                  marginTop: '4px'
                }}
              >
                {(props.title === 'PV' ||
                  props.title === 'Pv Inverter' ||
                  props.title === 'Pv DC-DC') && (
                  <SolarPowerIcon
                    style={{
                      fontSize: 30,
                      color: 'orange',
                      padding: '5px',
                      borderTopLeftRadius: '4px',
                      borderTopRightRadius: '4px'
                    }}
                  ></SolarPowerIcon>
                )}

                {props.title === 'Battery' && (
                  <BatteryCharging60Icon
                    style={{
                      fontSize: 40,
                      color: 'green',
                      padding: '5px',
                      borderTopLeftRadius: '4px',
                      borderTopRightRadius: '4px'
                    }}
                  ></BatteryCharging60Icon>
                )}
                {(props.title === 'AC Loads' || props.title === 'DC Loads' ||props.title === 'Loads') && (
                  <OutletIcon
                    style={{
                      fontSize: 30,
                      color: 'orange',
                      padding: '5px',
                      borderTopLeftRadius: '4px',
                      borderTopRightRadius: '4px'
                    }}
                  ></OutletIcon>
                )}
                {props.title === 'Grid' && (
                  <BoltIcon
                    style={{
                      fontSize: 30,
                      color: 'orange',
                      padding: '5px',
                      borderTopLeftRadius: '4px',
                      borderTopRightRadius: '4px'
                    }}
                  ></BoltIcon>
                )}
              </AvatarWrapper>
            )}

          {props.data && <Divider sx={{ width: '150%', marginTop: '0px' }} />}

          {props.data && (
            <Box
              sx={{
                pt: 1
              }}
            >
              {props.data.map((boxData, index) => {
                const formatted = formatPower(boxData.value, boxData.unit);
                return (
                  <Typography key={index}>
                    {formatted === 0 ? '0 ' : formatted}
                    {boxData.unit}
                  </Typography>
                );
              })}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}

export default TopologyBox;
